export const FETCH_ALL = `tunes/FETCH_ALL`
export const FETCH_ALL_FULFILLED = `tunes/FETCH_ALL_FULFILLED`
export const FETCH_ALL_FAILED = `tunes/FETCH_ALL_FULFILLED`